import type { SVGProps } from "react";

export default function LogoutIcon(props: Readonly<SVGProps<SVGSVGElement>>) {
  return (
    <svg
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.50244 5.83268C7.51253 4.02016 7.59291 3.03857 8.23322 2.39825C8.96548 1.66602 10.144 1.66602 12.501 1.66602H13.3343C15.6913 1.66602 16.8699 1.66602 17.6021 2.39825C18.3343 3.13048 18.3343 4.30899 18.3343 6.66602V13.3327C18.3343 15.6897 18.3343 16.8682 17.6021 17.6004C16.8699 18.3327 15.6913 18.3327 13.3343 18.3327H12.501C10.144 18.3327 8.96548 18.3327 8.23322 17.6004C7.59291 16.9601 7.51253 15.9785 7.50244 14.166"
        stroke="currentColor"
        strokeWidth="1.25528"
        strokeLinecap="round"
      />
      <path
        d="M12.5008 10H1.66748M1.66748 10L4.58415 7.5M1.66748 10L4.58415 12.5"
        stroke="currentColor"
        strokeWidth="1.25528"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
